import { ACTION_GET_CASHOUT_LIST, ACTION_GET_CASHOUT_LIST_ERROR, ACTION_GET_CASHOUT_LIST_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getCashoutListsReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_GET_CASHOUT_LIST:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_GET_CASHOUT_LIST_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_GET_CASHOUT_LIST_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}